export function loop(array, callback) {
  for (let i = 0; i < array.length; i++) {
    let element = array[i];
    let result = callback(element, i);
    if (!result) break;
  }
}
